import { useMutation, useQueryClient } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { UpdateSavingGoalPayload } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

interface UseUpdateSavingGoalOptions {
  onSuccess?: () => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useUpdateSavingGoal = (options?: UseUpdateSavingGoalOptions) => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, Error, UpdateSavingGoalPayload>({
    mutationFn: transferServices.updateSavingGoal,
    onSuccess: () => {
      // Invalidate goals list and individual goal to refetch
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SAVING_GOALS],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SAVING_GOAL],
      })

      if (options?.onSuccess) {
        options.onSuccess()
      }
    },
    onError: (error) => {
      if (options?.onError) {
        options.onError({
          errorMessage: error.message || 'Something went wrong',
          code: 'UNKNOWN_ERROR',
        })
      }
    },
  })

  return {
    ...mutation,
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
  }
}
